import React from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import getParentSection from '../../../../utils/layout/getParentSection';
import { Column } from 'nucleus-core/layout/flexbox';
import { defaultMemoize } from 'reselect';

/**
* Default renderer for a WIDGET type layout item.
* You can specify a container component to render your widget,
* and this wrapping class will provide the grid content and
* generate the parent style to pass to your component.
*/
export default class Widget extends React.Component {
  static displayName = 'Widget';
  static propTypes = {
    widget: PropTypes.object.isRequired,
    layoutItems: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    widgetContainerComponent: PropTypes.func.isRequired,
    children: PropTypes.node
  };
  constructor(props) {
    super(props);
    this.getParentStyle = this.getParentStyle.bind(this);
  }
  getParentStyle() {
    const { widget, layoutItems, theme } = this.props;
    return this._getParentStyle(widget, layoutItems, theme);
  }
  _getParentStyle = defaultMemoize((widget, layoutItems, theme) => {
    const parentSection = getParentSection(layoutItems, widget);
    return merge({},
      theme.global,
      theme.sections[parentSection.config.themeId],
      parentSection.config.style);
  });
  render() {
    const { widget, children } = this.props;
    return (
      <Column size={widget.layout.colspan}>
        <this.props.widgetContainerComponent
          parentStyle={this.getParentStyle()}
          {...this.props}>
            {children}
        </this.props.widgetContainerComponent>
      </Column>
    );
  }
}
